import produce from 'immer';
import {
	CHANGE_PASSWORD_ERROR,
	CHANGE_PASSWORD_PENDING,
	CHANGE_PASSWORD_SUCCESS,
	CHECK_EMAIL_VERIFICATION_TOKEN_ERROR,
	CHECK_EMAIL_VERIFICATION_TOKEN_PENDING,
	CHECK_EMAIL_VERIFICATION_TOKEN_SUCCESS,
	CHECK_PHONE_NUMBER_VERIFICATION_TOKEN_ERROR,
	CHECK_PHONE_NUMBER_VERIFICATION_TOKEN_PENDING,
	CHECK_PHONE_NUMBER_VERIFICATION_TOKEN_SUCCESS,
	REQUEST_EMAIL_VERIFICATION_ERROR,
	REQUEST_EMAIL_VERIFICATION_PENDING,
	REQUEST_EMAIL_VERIFICATION_SUCCESS,
	REQUEST_PHONE_NUMBER_VERIFICATION_TOKEN_ERROR,
	REQUEST_PHONE_NUMBER_VERIFICATION_TOKEN_PENDING,
	REQUEST_PHONE_NUMBER_VERIFICATION_TOKEN_SUCCESS,
} from '../constants/actions/accountActions';
import { CLOSE_ALL_MODALS_FULFILLED } from '../constants/actions/modalActions';
import { CREATE_RECIPIENT_PENDING } from '../constants/actions/recipientsActions';
import IAccountReducer from '../interfaces/reducers/accountReducer';
import { CREATE_RECIPIENT_FAILED, CREATE_RECIPIENT_FULFILLED } from './../constants/actions/recipientsActions';

const initialValues: IAccountReducer = {
	modalSubmitPending: false,
	modalSubmitError: false,
	modalSubmitErrorDetails: '',
	verificationId: null,
};

const accountReducer = produce((draft, action) => {
	switch (action.type) {
		case CHANGE_PASSWORD_SUCCESS: {
			draft.modalSubmitPending = false;
			draft.modalSubmitError = false;
			draft.modalSubmitErrorDetails = '';
			break;
		}
		case CHANGE_PASSWORD_PENDING: {
			draft.modalSubmitPending = true;
			draft.modalSubmitError = false;
			draft.modalSubmitErrorDetails = '';
			break;
		}
		case CHANGE_PASSWORD_ERROR: {
			draft.modalSubmitPending = false;
			draft.modalSubmitError = true;
			draft.modalSubmitErrorDetails = action.payload;
			break;
		}
		case REQUEST_PHONE_NUMBER_VERIFICATION_TOKEN_PENDING: {
			draft.modalSubmitError = false;
			draft.modalSubmitErrorDetails = '';
			break;
		}
		case REQUEST_PHONE_NUMBER_VERIFICATION_TOKEN_SUCCESS: {
			draft.modalSubmitError = false;
			draft.modalSubmitErrorDetails = '';
			draft.verificationId = action.payload;
			break;
		}
		case REQUEST_PHONE_NUMBER_VERIFICATION_TOKEN_ERROR: {
			draft.modalSubmitError = true;
			draft.modalSubmitErrorDetails = action.payload;
			break;
		}
		case CHECK_PHONE_NUMBER_VERIFICATION_TOKEN_PENDING: {
			draft.modalSubmitError = false;
			draft.modalSubmitErrorDetails = '';
			break;
		}
		case CHECK_PHONE_NUMBER_VERIFICATION_TOKEN_SUCCESS: {
			draft.modalSubmitError = false;
			draft.modalSubmitErrorDetails = '';
			break;
		}
		case CHECK_PHONE_NUMBER_VERIFICATION_TOKEN_ERROR: {
			draft.modalSubmitError = true;
			draft.modalSubmitErrorDetails = action.payload;
			break;
		}
		case REQUEST_EMAIL_VERIFICATION_PENDING: {
			draft.modalSubmitError = false;
			draft.modalSubmitErrorDetails = '';
			break;
		}
		case REQUEST_EMAIL_VERIFICATION_SUCCESS: {
			draft.modalSubmitError = false;
			draft.modalSubmitErrorDetails = '';
			break;
		}
		case REQUEST_EMAIL_VERIFICATION_ERROR: {
			draft.modalSubmitError = true;
			draft.modalSubmitErrorDetails = action.payload;
			break;
		}
		case CREATE_RECIPIENT_PENDING: {
			draft.modalSubmitPending = true;
			draft.modalSubmitError = false;
			draft.modalSubmitErrorDetails = '';
			break;
		}
		case CREATE_RECIPIENT_FULFILLED: {
			draft.modalSubmitPending = false;
			draft.modalSubmitError = false;
			draft.modalSubmitErrorDetails = '';
			break;
		}
		case CREATE_RECIPIENT_FAILED: {
			draft.modalSubmitPending = false;
			draft.modalSubmitError = true;
			draft.modalSubmitErrorDetails = action.payload;
			break;
		}
		case CLOSE_ALL_MODALS_FULFILLED: {
			draft.modalSubmitError = false;
			draft.modalSubmitErrorDetails = '';
			break;
		}
		case CHECK_EMAIL_VERIFICATION_TOKEN_PENDING: {
			draft.modalSubmitPending = true;
			draft.modalSubmitError = false;
			draft.modalSubmitErrorDetails = '';
			break;
		}
		case CHECK_EMAIL_VERIFICATION_TOKEN_SUCCESS: {
			draft.modalSubmitPending = false;
			draft.modalSubmitError = false;
			draft.modalSubmitErrorDetails = '';
			break;
		}
		case CHECK_EMAIL_VERIFICATION_TOKEN_ERROR: {
			draft.modalSubmitPending = false;
			draft.modalSubmitError = true;
			draft.modalSubmitErrorDetails = action.payload;
			break;
		}
		default:
			break;
	}
}, initialValues);

export default accountReducer;
